import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Footer from '@/components/layout/footer';
import MainContentWrapper from '@/components/layout/MainContentWrapper';
import Navbar from '@/components/layout/Navbar';
import { Box, CircularProgress } from '@montugroup/design-system';
import { BrandThemeProvider, uMeds } from '@montugroup/themes';
import { styled } from '@mui/material';

const MainContent = styled(Box)(() => ({
  height: '100%',
  padding: '100px 10px 20px 10px',
}));

export function PageLayout() {
  return (
    <MainContentWrapper>
      <BrandThemeProvider theme={uMeds}>
        <Navbar />
      </BrandThemeProvider>
      <MainContent id="main-content">
        <Suspense fallback={<CircularProgress />}>
          <Outlet />
        </Suspense>
      </MainContent>
      <Footer />
    </MainContentWrapper>
  );
}
